// Single source of truth for the API base path.
//
// VITE_API_BASE_URL is "/api" — the prefix the admin portal uses, which the
// Vite dev proxy (and the prod ingress) forwards to the ADMIN backend service.
// Read it here ONCE so client.ts and auth.ts can never drift. This module
// imports nothing, so it introduces no import cycle.

export const API_BASE: string = import.meta.env.VITE_API_BASE_URL ?? "";
